export default "__VITE_ASSET__BHhqUGY0__"